import React from "react";
import Header from "./Header";
import Content from "./Content";

const Layout = ({ children }) => {
    return (
        <div className="w-[100vw] h-[100vh]">
            <Header />
            <Content>{children}</Content>
        </div>
    );
};

export default Layout;
